import instance from '../utils/axios';

export const fetchEventUserGeneralSetting = async (data) => {
    const response = await instance.post('/blockMarket/blockEventTypes', data);
    return response.data;
}

export const fetchEventSettingMarketEvents = async (data) => {
    const response = await instance.post('/blockMarket/blockEvents', data);
    return response.data;
}

export const fetchUserGeneralSetting = async (data) => {
    const response = await instance.post('/matchGeneralSetting/getSetting', data);
    return response.data;
}

export const addEventUserGeneralSetting = async (data) => {
    const response = await instance.post('/matchGeneralSetting/addSetting', data);
    return response.data;
}